export const AUDIO_SESSION_WAVEFORM_INTERVAL_MS = 250;
export const AUDIO_SESSION_WAVEFORM_SAMPLE_COUNT = 48;

export const serializeWaveformSnapshot = (
  waveform: Float32Array | undefined,
  sampleCount = AUDIO_SESSION_WAVEFORM_SAMPLE_COUNT,
) => {
  if (!waveform || waveform.length === 0 || sampleCount <= 0) return undefined;

  const serialized: number[] = [];
  const stride = Math.max(1, Math.ceil(waveform.length / sampleCount));
  for (let index = 0; index < waveform.length; index += stride) {
    serialized.push(Number(waveform[index].toFixed(5)));
    if (serialized.length >= sampleCount) break;
  }
  return serialized;
};
